import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import { defineComponent, openBlock, createBlock, unref, isRef } from 'vue';
import { InputNumber as InputNumber$1 } from 'ant-design-vue';
import { useModelValue } from '../vc-utils';
var _sfc_main = /*#__PURE__*/defineComponent({
  __name: 'InputNumber',
  props: {
    value: [String, Number],
    unit: String
  },
  emits: ["update:value", "input", "change"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useModelValue = useModelValue(function () {
        if ((props.value !== undefined || props.value !== null) && typeof props.value === 'string') {
          return props.value.replaceAll(props.unit, '');
        }
        return props.value;
      }, function (val) {
        return emit('update:value', valueWithUnit(val));
      }),
      _value = _useModelValue.value;
    function valueWithUnit(value) {
      return notEmpty(value) && props.unit ? value + props.unit : value;
    }
    var notEmpty = function notEmpty(val) {
      return val !== undefined && val !== null && val !== '';
    };
    return function (_ctx, _cache) {
      return openBlock(), createBlock(unref(InputNumber$1), {
        value: unref(_value),
        "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
          return isRef(_value) ? _value.value = $event : null;
        }),
        onInput: _cache[1] || (_cache[1] = function (val) {
          return emit('input', valueWithUnit(val));
        }),
        onChange: _cache[2] || (_cache[2] = function (val) {
          return emit('change', valueWithUnit(val));
        })
      }, null, 8 /* PROPS */, ["value"]);
    };
  }
});
var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var InputNumber = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/input-number/InputNumber.js"]]);
export { InputNumber as default };